export enum HallowAnalyticsEvent {
  AdminAssigned = "Admin Assigned",
  AppleButtonTapped = "Apple Button Tapped",
  AudioStartDelayed = "Audio Start Delayed",
  AudioStarted = "Audio Started",
  AutocompletedPhoneNumber = "Autocompleted Phone Number",
  BibleCompleted = "Bible Completed",
  BibleStarted = "Bible Started",
  BookmarkAdded = "Bookmark Added",
  BookmarkRemoved = "Bookmark Removed",
  CategoriesCompleted = "Categories Completed",
  CategoriesStarted = "Categories Started",
  ChangedBibleChapter = "Changed Bible Chapter",
  ChangedTranscriptAutoScrollSetting = "Changed Transcript Auto Scroll Setting",
  ChangedTranscriptTextSizeSetting = "Changed Transcript Text Size Setting",
  ChangedTranscriptColorSetting = "Changed Transcript Color Setting",
  Close = "Close",
  ClosedMySavesFilter = "Closed My Saves Filter",
  ClosedShareAudioView = "Closed Share Audio View",
  CollectionFavorited = "Collection Favorited",
  CommunityReportResponded = "Community Report Responded",
  CommunityReportedActivityDeleted = "Community Reported Activity Deleted",
  CompletedKidsProfileCreationStep = "Completed Kids Profile Creation Step",
  CompletedOnboardingStep = "Completed Onboarding Step",
  CreatedNotreDameEmailAccount = "Created Notre Dame Email Account",
  DonationPurchased = "Donation Purchased",
  DraggedFeaturedSessionOrder = "Dragged Featured Session Order",
  DraggedQueueItem = "Dragged Queue Item",
  DraggedTimeSlider = "Dragged Time Slider",
  EditedJournal = "Edited Journal",
  EditedHighlightColor = "Edited Highlight Color",
  EditedNote = "Edited Note",
  EmailButtonTapped = "Email Button Tapped",
  EnteredEmail = "Entered Email",
  EnteredEmailVerification = "Entered Email Verification",
  EnteredUsername = "Entered Username",
  EnteredIncorrectParentPIN = "Entered Incorrect Parent PIN",
  GoogleButtonTapped = "Google Button Tapped",
  EnteredProfileCreateFlow = "Entered Profile Create Flow",
  HeraldPrizeRedemptionClicked = "Herald Prize Redemption Clicked",
  HeraldPrizeRedemptionSubmitted = "Herald Prize Redemption Submitted",
  HighlightAdded = "Highlight Added",
  HighlightRemoved = "Highlight Removed",
  LoopChanged = "Loop Changed",
  MaximizedPlayer = "Maximized Player",
  MinimizedPlayer = "Minimized Player",
  NoteAdded = "Note Added",
  NoteRemoved = "Note Removed",
  OpenedBibleBookMenu = "Opened Bible Book Menu",
  OpenedBibleChapterMenu = "Opened Bible Chapter Menu",
  OpenedMySaves = "Opened My Saves",
  PlayerBeganTrack = "Player Began Track",
  PlayerDestroyed = "Player Destroyed",
  PlayerEndedTrack = "Player Ended Track",
  PlayerInitialized = "Player Initialized",
  PostedContentToCommunity = "Posted Content to Community",
  RemovedPost = "Removed Post",
  SelectedAssignmentCollection = "Selected Assignment Collection",
  SelectedBibleTranslation = "Selected Bible Translation",
  SelectedChoice = "Selected Choice",
  SelectedRecommendationChoice = "Selected Recommendation Choice",
  SelectedSubtitles = "Selected Subtitles",
  SelectedTextChanged = "Selected Text Changed",
  SelectedTriviaChoice = "Selected Trivia Choice",
  ShowNative = "Show Native",
  SkippedOnboardingStep = "Skipped Onboarding Step",
  SubmittedCancellationFeedback = "Submitted Cancellation Feedback",
  SubmittedOtherCancellationFeedback = "Submitted Other Cancellation Feedback",
  SubmittedNotreDameForm = "Submitted Notre Dame Form",
  SubscribedNotreDameUser = "Subscribed Notre Dame User",
  SubscriptionPurchased = "Subscription Purchased",
  SubscriptionUpgraded = "Subscription Upgraded",
  TappedAddAssignment = "Tapped Add Assignment",
  TappedAddContentToCommunity = "Tapped Add Content to Community",
  TappedAddClass = "Tapped Add Class",
  TappedAddClassMember = "Tapped Add Class Member",
  TappedAddDueDate = "Tapped Add Due Date",
  TappedAddToFeatured = "Tapped Add to Featured",
  TappedAddMember = "Tapped Add Member",
  TappedAddFriendToFamilyPlan = "Tapped Add Friend to Family Plan",
  TappedAddFamilyToFamilyPlan = "Tapped Add Family to Family Plan",
  TappedCreateChildAccount = "Tapped Create Child Account",
  TappedAddPartnershipContent = "Tapped Add Partnership Content",
  TappedAddRsvpBlock = "Tapped Add RSVP Block",
  TappedAddKidsProfile = "Tapped Add Kids Profile",
  TappedAddStudent = "Tapped Add Student",
  TappedAddTeacher = "Tapped Add Teacher",
  TappedAddToRoutine = "Tapped Add to Routine",
  TappedAdminDashboardTab = "Tapped Admin Dashboard Tab",
  TappedApplePay = "Tapped Apple Pay",
  TappedApplyFilter = "Tapped Apply Filter",
  TappedApplyPromoCode = "Tapped Apply Promo Code",
  TappedAssignAsMember = "Tapped Assign As Member",
  TappedAssignAsAdmin = "Tapped Assign As Admin",
  TappedAssignment = "Tapped Assignment",
  TappedAssignmentOption = "Tapped Assignment Option",
  TappedAssignmentSearch = "Tapped Assignment Search",
  TappedBack = "Tapped Back",
  TappedBannerDownload = "Tapped Banner Download",
  TappedModalDownload = "Tapped Modal Download",
  TappedBibleAction = "Tapped Bible Action",
  TappedBibleBook = "Tapped Bible Book",
  TappedBibleChapter = "Tapped Bible Chapter",
  TappedBibleTranslations = "Tapped Bible Translations",
  TappedBroadcastMessageEditorGroups = "Tapped Broadcast Message Editor Groups",
  TappedBulkChangeAccountType = "Tapped Bulk Change Account Type",
  TappedBuyGift = "Tapped Buy Gift",
  TappedBuyNow = "Tapped Buy Now",
  TappedCampaignOption = "Tapped Campaign Option",
  TappedCampaignSession = "Tapped Campaign Session",
  TappedCancelSubscription = "Tapped Cancel Subscription",
  TappedCategoriesSummary = "Tapped Categories Summary",
  TappedClassAssignments = "Tapped Class Assignments",
  TappedClassOption = "Tapped Class Option",
  TappedClassRoster = "Tapped Class Roster",
  TappedClassSearch = "Tapped Class Search",
  TappedClose = "Tapped Close",
  TappedCloseCategories = "Tapped Close Categories",
  TappedCloseTheWord = "Tapped Close The Word",
  TappedCommunityMemberOptions = "Tapped Community Member Options",
  TappedCommunityMemberProfile = "Tapped Community Member Profile",
  TappedCalendarDate = "Tapped Calendar Date",
  TappedCommunityPermissionsToggle = "Tapped Community Permissions Toggle",
  TappedCommunityProfile = "Tapped Community Profile",
  TappedCommunityReportInfo = "Tapped Community Report Info",
  TappedCommunitySettings = "Tapped Community Settings",
  TappedChangeParentPINSettings = "Tapped Change Parent PIN Settings",
  TappedConfirmDOB = "Tapped Confirm DOB",
  TappedContentCategory = "Tapped Content Category",
  TappedContinue = "Tapped Continue",
  TappedContinueToCancellation = "Tapped Continue to Cancellation",
  TappedContactHallowParishLead = "Tapped Contact Hallow Parish Lead",
  TappedCopyText = "Tapped Copy Text",
  TappedCreateEvent = "Tapped Create Event",
  TappedCreditOrDebitCard = "Tapped Credit or Debit Card",
  TappedDashboardChartTimeframe = "Tapped Dashboard Chart Timeframe",
  TappedDeleteAccount = "Tapped Delete Account",
  TappedDeleteAnnouncement = "Tapped Delete Announcement",
  TappedDeleteBroadcastMessage = "Tapped Delete Broadcast Message",
  TappedDeleteMember = "Tapped Delete Member",
  TappedDeselectAllTiles = "Tapped Deselect All Tiles",
  TappedDetails = "Tapped Details",
  TappedDiscardBroadcastMessage = "Tapped Discard Broadcast Message",
  TappedDiscover = "Tapped Discover",
  TappedDonationAddNote = "Tapped Donation Add Note",
  TappedDownloadCSVTemplate = "Tapped Download CSV Template",
  TappedDownloadOnTheAppStore = "Tapped Download on the App Store",
  TappedEdit = "Tapped Edit",
  TappedEditEvent = "Tapped Edit Event",
  TappedEditHighlight = "Tapped Edit Highlight",
  TappedEditNote = "Tapped Edit Note",
  TappedEvent = "Tapped Event",
  TappedEventsCalendar = "Tapped Events Calendar",
  TappedEventSection = "Tapped Event Section",
  TappedEditMember = "Tapped Edit Member",
  TappedEditProfileImage = "Tapped Edit Profile Image",
  TappedExitInCancellationFlow = "Tapped Exit in Cancellation Flow",
  TappedExitOnEditMember = "Tapped Exit on Edit Member",
  TappedExplorePrayers = "Tapped Explore Prayers",
  TappedExploreMorePrayers = "Tapped Explore More Prayers",
  TappedExportCSV = "Tapped Export CSV",
  TappedExportJournalsSettings = "Tapped Export Journals Settings",
  TappedExportSupporterCSV = "Tapped Export Supporter CSV",
  TappedExportTXT = "Tapped Export TXT",
  TappedFastForward = "Tapped Fast Forward",
  TappedFollowAudio = "Tapped Follow Audio",
  TappedForgotParentPin = "Tapped Forgot Parent PIN",
  TappedGCash = "Tapped GCash",
  TappedGetItOnGooglePlay = "Tapped Get it on Google Play",
  TappedGivingEmailCheckbox = "Tapped Giving Email Checkbox",
  TappedGivingFeeCoverageCheckbox = "Tapped Giving Fee Coverage Checkbox",
  TappedGooglePay = "Tapped Google Pay",
  TappedGroup = "Tapped Group",
  TappedGroupInvite = "Tapped Group Invite",
  TappedGroupJoinRequest = "Tapped Group Join Request",
  TappedGroupMembers = "Tapped Group Members",
  TappedHaveAPromoCode = "Tapped Have a Promo Code",
  TappedIAmAStudentLogin = "Tapped I am a Student Login",
  TappedImportStudents = "Tapped Import Students",
  TappedImportTeachers = "Tapped Import Teachers",
  TappedInviteFriends = "Tapped Invite Friends",
  TappedInviteFriendsToTrivia = "Tapped Invite Friends to Trivia",
  TappedJoinCampaign = "Tapped Join Campaign",
  TappedJoinChallenge = "Tapped Join Challenge",
  TappedLeaveGroup = "Tapped Leave Group",
  TappedListenForFree = "Tapped Listen for Free",
  TappedLogBackIn = "Tapped Log Back In",
  TappedLogOut = "Tapped Log Out",
  TappedLogin = "Tapped Log In",
  TappedMagicLinkHelp = "Tapped Magic Link Help",
  TappedMakeADonation = "Tapped Make a Donation",
  TappedManageProfiles = "Tapped Manage Profiles",
  TappedMemberOption = "Tapped Member Option",
  TappedMemberSearch = "Tapped Member Search",
  TappedMergeAccountsSendVerification = "Tapped Merge Accounts Send Verification",
  TappedModalPrimaryCTA = "Tapped Modal Primary CTA",
  TappedModalSecondaryCTA = "Tapped Modal Secondary CTA",
  TappedMoreGame = "Tapped More Game",
  TappedMoreGamesItem = "Tapped More Games Item",
  TappedMySavesCard = "Tapped My Saves Card",
  TappedMySavesCardMoreMenu = "Tapped My Saves Card More Menu",
  TappedMySavesFilter = "Tapped My Saves Filter",
  TappedNewJournal = "Tapped New Journal",
  TappedNextUp = "Tapped Next Up",
  TappedNotMyChild = "Tapped Not My Child",
  TappedNotNowOnSMSPrompt = "Tapped Not Now on SMS Prompt",
  TappedPause = "Tapped Pause",
  TappedPaymentApplePay = "Tapped Apple Pay",
  TappedPaymentCard = "Tapped Card",
  TappedPaymentGooglePay = "Tapped Google Pay",
  TappedPaymentPaypal = "Tapped Paypal",
  TappedPaypal = "Tapped Paypal",
  TappedPlay = "Tapped Play",
  TappedPlayAll = "Tapped Play All",
  TappedPlayNextSession = "Tapped Play Next Session",
  TappedPlayRadioStation = "Tapped Play Radio Station",
  TappedPlaySession = "Tapped Play Session",
  TappedPlayVideo = "Tapped Play Video",
  TappedPrayerInCancellation = "Tapped Prayer in Cancellation",
  TappedPrayTodaysSession = "Tapped Pray Todays Session",
  TappedPrimaryCTA = "Tapped Primary CTA",
  TappedProfileSelector = "Tapped Profile Selector",
  TappedProfileSettings = "Tapped Profile Settings",
  TappedQueue = "Tapped Queue",
  TappedQueueItem = "Tapped Queue Item",
  TappedRedeemGiftSubscription = "Tapped Redeem Gift Subscription",
  TappedReflectOnPostPrayer = "Tapped Reflect on Post Prayer",
  TappedRefreshApp = "Tapped Refresh App",
  TappedRegiftGiftSubscription = "Tapped Regift Gift Subscription",
  TappedRefundSubscription = "Tapped Refund Subscription",
  TappedRemoveMember = "Tapped Remove Member",
  TappedReportATranscriptConcern = "Tapped Report a Transcript Concern",
  TappedReportObject = "Tapped Report Object",
  TappedReportReason = "Tapped Report Reason",
  TappedRemindMeOnSMSPrompt = "Tapped Remind Me on SMS Prompt",
  TappedRemoveCommunityMember = "Tapped Remove Community Member",
  TappedRemovePost = "Tapped Remove Post",
  TappedRemoveRsvpBlock = "Tapped Remove RSVP Block",
  TappedResetPassword = "Tapped Reset Password",
  TappedRestoreSubscriptions = "Tapped Restore Subscriptions",
  TappedResumeCategories = "Tapped Resume Categories",
  TappedResumeSession = "Tapped Resume Session",
  TappedResumeTheWord = "Tapped Resume The Word",
  TappedResumeTrivia = "Tapped Resume Trivia",
  TappedReviewInSettings = "Tapped Review in Settings",
  TappedRewind = "Tapped Rewind",
  TappedRsvp = "Tapped RSVP",
  TappedRsvpList = "Tapped RSVP List",
  TappedRsvpOption = "Tapped RSVP Option",
  TappedRsvpResponse = "Tapped RSVP Response",
  TappedPremiumContentToggle = "Tapped Premium Content Toggle",
  TappedPublishEventChanges = "Tapped Publish Event Changes",
  TappedSaveEventDate = "Tapped Save Event Date",
  TappedSaveEventDescription = "Tapped Save Event Description",
  TappedSaveEventHosts = "Tapped Save Event Hosts",
  TappedSaveEventImage = "Tapped Save Event Image",
  TappedSaveEventLocation = "Tapped Save Event Location",
  TappedSaveEventType = "Tapped Save Event Type",
  TappedSaveOnEditMember = "Tapped Save on Edit Member",
  TappedScholarshipCTA = "Tapped Scholarship CTA",
  TappedSearch = "Tapped Search",
  TappedSecondaryCTA = "Tapped Secondary CTA",
  TappedSectionActionButton = "Tapped Section Action Button",
  TappedSectionItem = "Tapped Section Item",
  TappedSectionItemMoreMenu = "Tapped Section Item More Menu",
  TappedSectionSeeAll = "Tapped Section See All",
  TappedSelectAllPrayersforAssignment = "Tapped Select All Prayers for Assignment",
  TappedSelectPrayerforAssignment = "Tapped Select Prayer for Assignment",
  TappedSelectSubscriptionPlan = "Tapped Select Subscription Plan",
  TappedSendBroadcastMessage = "Tapped Send Broadcast Message",
  TappedSendEventAnnouncement = "Tapped Send Event Announcement",
  TappedSendRsvp = "Tapped Send RSVP",
  TappedSendUpdate = "Tapped Send Update",
  TappedSentBroadcastMessageGroups = "Tapped Sent Broadcast Message Groups",
  TappedShareCampaign = "Tapped Share Campaign",
  TappedShareCampaignSessionCount = "Tapped Share Campaign Session Count",
  TappedShareCategories = "Tapped Share Categories",
  TappedShareChallenge = "Tapped Share Challenge",
  TappedShareCollection = "Tapped Share Collection",
  TappedShareEvent = "Tapped Share Event",
  TappedShareEventAction = "Tapped Share Event Action",
  TappedShareTrivia = "Tapped Share Trivia",
  TappedShareTheWord = "Tapped Share The Word",
  TappedShuffle = "Tapped Shuffle",
  TappedShuffleAll = "Tapped Shuffle All",
  TappedShuffleTiles = "Tapped Shuffle Tiles",
  TappedSkip = "Tapped Skip",
  TappedSkipBack = "Tapped Skip Back",
  TappedSkipForward = "Tapped Skip Forward",
  TappedSkipIntro = "Tapped Skip Intro",
  TappedSleepTimer = "Tapped Sleep Timer",
  TappedStartCategories = "Tapped Start Categories",
  TappedStartCreateEvent = "Tapped Start Create Event",
  TappedStartTheWord = "Tapped Start The Word",
  TappedStartTrivia = "Tapped Start Trivia",
  TappedSubmitStripe = "Tapped Submit Stripe",
  TappedSubscribeToListen = "Tapped Subscribe to Listen",
  TappedSubscribeToWatch = "Tapped Subscribe to Watch",
  TappedSwitchProfile = "Tapped Switch Profile",
  TappedRemoveCommunityContent = "Tapped Remove Community Content",
  TappedTextOnScreen = "Tapped Text on Screen",
  TappedTheWordSummary = "Tapped The Word Summary",
  TappedToAcceptOffer = "Tapped to Accept Offer",
  TappedToCompleteImport = "Tapped to Complete Import",
  TappedToConfirmStudentProfile = "Tapped to Confirm Student Profile",
  TappedToDeclineOffer = "Tapped to Decline Offer",
  TappedToSwitchToProfile = "Tapped to Switch to Profile",
  TappedTrackSettings = "Tapped Track Settings",
  TappedTranscriptSettings = "Tapped Transcript Settings",
  TappedTranscriptOption = "Tapped Transcript Option",
  TappedTranscriptText = "Tapped Transcript Text",
  TappedTriviaRecommendation = "Tapped Trivia Recommendation",
  TappedTriviaSummary = "Tapped Trivia Summary",
  TappedTriviaWeeklyLeaderboard = "Tapped Trivia Weekly Leaderboard",
  TappedTryHallowForFree = "Tapped Try Hallow for Free",
  TappedUnlinkSmallGroup = "Tapped Unlink Small Group",
  TappedUpdateGivingCampaign = "Tapped Update Giving Campaign",
  TappedUpdateProfile = "Tapped Update Profile",
  TappedUseEmailInstead = "Tapped Use Email Instead",
  TappedUsePasswordInstead = "Tapped Use Password Instead",
  TappedViewAnnouncements = "Tapped View Announcements",
  TappedViewDetails = "Tapped View Details",
  TappedViewGuestList = "Tapped View Guest List",
  TappedWatchForFree = "Tapped Watch for Free",
  TappedWebAppTabBar = "Tapped Web App Tab Bar",
  TappedWebAppNav = "Tapped Web App Nav",
  TappedWebCommunity = "Tapped Web Community",
  TappedWebCommunityDropdown = "Tapped Web Community Dropdown",
  TappedWriteBroadcastMessage = "Tapped Write Broadcast Message",
  TextSelected = "Text Selected",
  TheWordCompleted = "The Word Completed",
  TheWordStarted = "The Word Started",
  TimerChanged = "Timer Changed",
  TimerEnded = "Timer Ended",
  ToggledFreeTrial = "Toggled Free Trial",
  ToggledStreakSettings = "Toggled Streak Settings",
  ToggledSubscriptionType = "Toggled Subscription Type",
  ToggledTrialReminder = "Toggled Trial Reminder",
  ToggledUseSameDateForAllAssignments = "Toggled Use Same Date for All Assignments",
  ToggledViewOrderSummary = "Tapped View Order Summary",
  TookPostPrayerScreenAction = "Took Post Prayer Screen Action",
  TrackPayment = "Track Payment",
  TriviaCompleted = "Trivia Completed",
  TriviaStarted = "Trivia Started",
  VerifiedNotreDameCaptcha = "VerifiedNotreDameCaptcha",
  VideoEnded = "Video Ended",
  ViewedAdminDashboardScreen = "Viewed Admin Dashboard Screen",
  ViewedCancellationFeedback = "Viewed Cancellation Feedback",
  ViewedCancellationOffer = "Viewed Cancellation Offer",
  ViewedCancelSubscription = "Viewed Cancel Subscription",
  ViewedErrorMessage = "Viewed Error Message",
  ViewedFollowAudioButton = "Viewed Follow Audio Button",
  ViewedImportError = "Viewed Import Error",
  ViewedJournalEntry = "Viewed Journal Entry",
  ViewedModal = "Viewed Modal",
  ViewedNotreDameRegister = "Viewed Notre Dame Register",
  ViewedPostPrayerScreen = "Viewed Post Prayer Screen",
  ViewedRefundSubscription = "Viewed Refund Subscription",
  ViewedScreen = "Viewed Screen",
  ViewedShareChallengeDialog = "Viewed Share Challenge Dialog",
  ViewedShareCollectionDialog = "Viewed Share Collection Dialog",
  ViewedSMSPromptDialog = "Viewed SMS Prompt Dialog",
  ViewedSubscriptionPlans = "Viewed Subscription Plans",
  ViewedSubscriptionScreen = "Viewed Subscription Screen",
  ViewedTextOnScreen = "Viewed Text on Screen",
  TappedSearchCommunityLibrary = "Tapped Search Community Library",
}
